import axios from 'axios';
import type {
  IGetManagedAccessKdpsQueryParams,
  IGetManagedAccessKdpsResponse,
} from '@/app-package';

const getManagedAccessKdps = async ({
  page,
  limit,
  sortBy,
  sortOrder,
  source,
  startDate,
  endDate,
}: IGetManagedAccessKdpsQueryParams): Promise<IGetManagedAccessKdpsResponse> => {
  const { data } = await axios.get<IGetManagedAccessKdpsResponse>(
    `/supra/managed_access/kdps`,
    {
      params: {
        page,
        limit,
        sortBy,
        sortOrder,
        source,
        startDate,
        endDate,
      },
    },
  );
  return data;
};

export default getManagedAccessKdps;
